<template>
  <basic-container>

    <div>
      <div class="search_group">
        <el-input
          v-model="searchParam"
          placeholder="请输入查询参数"
          clearable
          style="width: 200px; margin-left: 10px; margin-right: 10px;"
          size="small"
        ></el-input>
        <el-button @click="searchAct" icon="el-icon-search" size="small" type="success">查询</el-button>
        <el-button  v-if="permissionList.addBtn"  @click="addBlackDeviceIp" icon="el-icon-plus" size="small" type="primary">新增</el-button>
        <el-button  v-if="permissionList.delBtn" @click="delProject"   icon="el-icon-delete" size="small" type="danger">删除</el-button>
      </div>
      <el-table :max-height="autoTableHeight"
        ref="eltable"
        v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
        @selection-change="handleSelectionChange"
        >
        <el-table-column  align="center" type="selection" width="50"></el-table-column>
        <el-table-column  align="left" prop="id" label="ID" width="80"></el-table-column>
        <el-table-column  align="center" prop="title" label="标题" :min-width="200"></el-table-column>
        <el-table-column  align="center"  prop="filename" label="文件" :min-width="300"></el-table-column>
        <el-table-column  align="center" label="状态">
          <template slot-scope="scope">
            <span :class="
                          scope.row.status == 0
                            ? 'initcolor'
                            : scope.row.status == 1
                            ? 'ingcolor'
                            : scope.row.status == 2
                            ? 'passcolor'
                            : scope.row.status == 3
                            ? 'errorcolor'
                            : scope.row.status == 4
                            ? 'errorcolor'
                            : ''
                          ">{{ getStatusText(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column  align="center"  prop="addtime" label="修改时间" width="200"></el-table-column>
        <el-table-column  align="center"  prop="adduser" label="修改人" width="200"></el-table-column>

      </el-table>
      <div class="table_pagination">
        <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
        </el-pagination>
      </div>
    </div>
    <addBlackDeviceIpDialog
      :blackDeviceIpDailogFlag.sync="showAddDialog"
      :editId = "editId"
      :editType = "editType"
      :row = 'editRow'
      @submit="getList"
      ></addBlackDeviceIpDialog>
  </basic-container>
</template>

<script>
import { getBlackDeviceIpList, batchRemove } from '@/api/ad/blackdeviceip'
import {mapGetters} from "vuex";
import pagination from '@/util/mixins/pagination'
import ListMixins from '@/util/mixins/listPage';
import addBlackDeviceIpDialog from './dialogs/blackDeviceIpDialog.vue'
export default {
  mixins: [pagination, ListMixins],
  data () {
    return {
      searchParam: '',
      editRow: {},
      showAddDialog: false, // 添加这个属性
      editType: '', // 传入编辑弹框类型
      rowData: {}, // 查看的详情数据
      selectionList: [],
      listLoading: false,
      tableData: [],
      totalEl: 0,
      pageNo: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 50, 100]
    }
  },
  components: {
    addBlackDeviceIpDialog
  },
  mounted () {
    this.getList(); // 初始化时获取列表
  },
  computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.blackDeviceIp_add, false),
          delBtn: this.vaildData(this.permission.blackDeviceIp_delete, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
  },
  methods: {
     // 获取状态文字
     getStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '启用中',
        2: '已过期',
        3: '异常',
        4: '缺失文件'
      };
      return statusMap[status] || '未知状态';
    },
    
    addBlackDeviceIp () {
      this.showAddDialog = true;
      this.editType = 'add';
      this.editRow = {}; // 清空编辑数据
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        search: this.searchParam ? this.searchParam : '',
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getBlackDeviceIpList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    handleSelectionChange (val) {
      this.selectionList = val
    },
    delProject () {
      if (this.selectionList.length === 0) {
        this.$message({
          message: '请先选择要删除的项目',
          type: 'warning'
        });
      } else {
        const ids = this.selectionList.map(item => item.id).join(',')
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
            batchRemove(ids).then((res)=> {
            console.log(res)
            if(res.data.code === 200 && res.data.success) this.getList()
          })
        })
      }
    },
  },
  watch: {
    tabs (val) {
      this.current = 1
      this.searchTime = ''
      if(val === '0') {
        this.getList()
      }
    },
    showAddDialog (val) {
      if(!val) {
        this.editId = ''
        this.editType = ''
        this.editRow = {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .initcolor{
    color:#0000FF
  }
  .ingcolor{
    color:#009588
  }
  .errorcolor{
    color:#D9001B
  }
  .passcolor{
    color:#000000
  }
</style>
